<script setup lang="ts">
import { useWhiteboardToolbarStore } from '@@/pinia/whiteboard_toolbar'
import { storeToRefs } from 'pinia'

const whiteboardToolbarStore = useWhiteboardToolbarStore()
const { dropOverlayMessage } = storeToRefs(whiteboardToolbarStore)
</script>

<template>
  <Transition name="fade">
    <!-- Because the v-if is at the parent component, we don't need a v-if inside here. -->
    <!-- We can safely disable this rule. -->
    <!-- eslint-disable-next-line vue/require-toggle-inside-transition -->
    <div
      :class="[
        'absolute',
        'inset-0',
        'z-dragging-overlay',
        'bg-grape-500/50 dark:bg-canary-500/[0.35]',
        'will-change-[background-color]',
        'pointer-events-none',
      ]"
    >
      <div
        :class="[
          'fixed',
          'top-5',
          'inset-x-0',
          'rounded-lg',
          'shadow-elevation-3',
          'mx-auto',
          'w-fit',
          'px-3',
          'py-2',
          'bg-light-ui-100 dark:bg-dark-ui-100',
        ]"
      >
        <p
          :class="[
            'text-body-extra-small',
            'font-sans',
            'text-center',
            'text-dark-text-100 dark:text-light-text-100',
            'break-words',
          ]"
        >
          {{ dropOverlayMessage }}
        </p>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.fade-enter-from,
.fade-leave-to {
  @apply bg-grape-500/0 dark:bg-canary-500/0;
}

.fade-enter-to,
.fade-leave-from {
  @apply bg-grape-500/50 dark:bg-canary-500/[0.35];
}

.fade-enter-active {
  @apply duration-180 ease-out;
}

.fade-leave-active {
  @apply duration-180 ease-in;
}
</style>
